import * as React from "react";
import * as Helpers from "../helpers";
import styles from "./InputText.module.scss";
import InputOptions from "./InputOptions";

type InputBooleanProps = InputProps & {
    show_only_yes?: boolean;
    use_checkbox?: boolean;
}

const InputBoolean: React.FunctionComponent<InputBooleanProps> = props =>
{
    const elemRef = React.useRef<HTMLDivElement>(null);

    if (props.use_checkbox === true)
    {
        const showValidation = !Helpers.TriggerValidationSingle((props.value || "").trim(), props.required) && props.validation_triggered;
        if (showValidation && !props.validation_get_scrolled() && elemRef.current)
        {
            props.validation_set_scrolled();
            elemRef.current.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
        }

        return <div ref={elemRef} className={styles.outer}>
            <div className={`${styles.wrapper} ${showValidation ? styles.hasValidation : ""}`}>
                <label htmlFor={props.name}>
                    <input
                        className={`form-control ${styles.formControl}`}
                        id={props.name}
                        name={props.name}
                        type="checkbox"
                        value="true"
                        checked={props.value === "true"}
                        onChange={(ev) => (props.update_value(props.name, ev.currentTarget.checked ? "true" : "false"))}
                    />
                    {props.label} {props.required ? <sub className={styles.required}>*</sub> : null}
                </label>
            </div>
            {props.description}
            {showValidation ? <div className={styles.validation} role="alert">{props.validation_message ? <>{props.validation_message}</> : <>Please confirm <span style={{ textTransform: "lowercase" }}>{props.label}</span>.</>}</div> : null}
        </div>
    }
    else
    {
        let options: { label: string, value: string }[] = [
            { label: "Yes", value: "true" }
        ];

        if (props.show_only_yes !== true)
        {
            options.push({ label: "No", value: "false" });
        }

        return <InputOptions
            label={props.label}
            name={props.name}
            value={props.value}
            required={props.required}
            validation_triggered={props.validation_triggered}
            validation_message={props.validation_message}
            validation_get_scrolled={props.validation_get_scrolled}
            validation_set_scrolled={props.validation_set_scrolled}
            description={props.description}
            update_value={props.update_value}
            is_exclusive={true}
            options={options}
        />;
    }
}

export default InputBoolean;